<template>
    <div class="notifications-dropdown">
        <b-nav-item-dropdown
            right
            no-caret
            menu-class="notifications-menu"
            @click="onDropdownShow"
        >
            <template #button-content>
                <div class="notification-bell">
                    <md-icon icon="notifications" class="bell-icon" :class="{ '__shake': hasUnread }" />
                    <b-badge
                        v-if="unreadCount > 0"
                        variant="danger"
                        pill
                        class="notification-badge"
                    >
                        {{ unreadCount > 99 ? '99+' : unreadCount }}
                    </b-badge>
                </div>
            </template>

            <div class="notifications-header">
                <span class="notifications-title">{{ $t('notifications.title') }}</span>
                <b-button
                    v-if="unreadCount > 0 && false"
                    variant="link"
                    size="sm"
                    class="mark-all-read"
                    @click.stop="markAllAsRead"
                >
                    {{ $t('notifications.markAllRead') }}
                </b-button>
            </div>

            <b-dropdown-divider />

            <div class="notifications-list" v-if="!loading">
                <div
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="notification-item"
                    :class="{ 'unread': !notification.read }"
                    @click="handleNotificationClick(notification)"
                >
                    <div class="notification-icon" :class="getIconClass(notification.type)">
                        <md-icon :icon="getIcon(notification.type)" />
                    </div>
                    <div class="notification-content">
                        <p class="notification-message">{{ notification.message }}</p>
                        <span class="notification-time">{{ formatTime(notification.createdAt) }}</span>
                    </div>
                    <div v-if="!notification.read" class="unread-indicator"></div>
                </div>

                <div v-if="notifications.length === 0" class="empty-notifications">
                    <md-icon icon="notifications_off" class="empty-icon" />
                    <p>{{ $t('notifications.empty') }}</p>
                </div>
            </div>

            <div v-else class="notifications-loading">
                <b-spinner small variant="primary" />
            </div>

            <b-dropdown-divider v-if="notifications.length > 0 && false" />

            <div v-if="notifications.length > 0 && false" class="notifications-footer">
                <b-button variant="link" size="sm" @click="viewAll">
                    {{ $t('notifications.viewAll') }}
                </b-button>
            </div>
        </b-nav-item-dropdown>
    </div>
</template>

<script>
export default {
    name: 'NotificationsDropdown',
    data() {
        return {
            loading: false,
            notifications: []
        };
    },
    computed: {
        unreadCount() {
            return this.notifications.filter(n => !n.read).length;
        },
        hasUnread() {
            return this.unreadCount > 0;
        }
    },
    methods: {
        fetchNotifications() {
            this.loading = true;
            /*
            this.$root.api.get('/notifications')
                .then((res) => {
                    this.notifications = res.data || [];
                })
                .catch(this.$root.handleRequestError)
                .finally(() => this.loading = false);
            */
           this.$root.api.get('/dashboard/evidences')
                .then((res) => {

                    const pendingEvidences  = res.data.evidences;
                    pendingEvidences.forEach(element => {
                        if (element.evidenceStatus === "pending" && element.evidenceProvidedAt === null && !this.isTokenExpired(element.tokenExpireAt)) {
                            const timeText = this.formatRemainingTime(element.tokenExpireAt);
                            this.notifications.push({
                                id: element.id,
                                read: false,
                                type: "evidence_pending",
                                message: `Evidencia pendiente: ${element.service.serviceNumber} (${timeText})`,
                                createdAt: element.createdAt,
                                actionUrl: this.buildEvidenceUrl(element.token)
                            })
                        }
                    });
                })
                .catch(this.$root.handleRequestError)
                .finally(() => this.loading = false);
        },
        onDropdownShow() {
            this.notifications = [];
            this.fetchNotifications();
        },
        markAllAsRead() {
            this.$root.api.post('/notifications/mark-all-read')
                .then(() => {
                    this.notifications = this.notifications.map(n => ({ ...n, read: true }));
                })
                .catch(this.$root.handleRequestError);
        },
        markAsRead(notification) {
            if (notification.read) return;
            this.$root.api.post(`/notifications/${notification.id}/mark-read`)
                .then(() => {
                    const index = this.notifications.findIndex(n => n.id === notification.id);
                    if (index !== -1) {
                        this.notifications[index].read = true;
                    }
                })
                .catch(this.$root.handleRequestError);
        },
        handleNotificationClick(notification) {
            // this.markAsRead(notification);
            if (notification.actionUrl) {
                window.open(notification.actionUrl, '_blank');
            }
        },
        viewAll() {
            this.$router.push('/notifications');
        },
        getIcon(type) {
            const icons = {
                'evidence_pending': 'photo_library',
                'evidence_approved': 'check_circle',
                'evidence_rejected': 'cancel',
                'service_assigned': 'directions_car',
                'service_updated': 'update',
                'system': 'info',
                'default': 'notifications'
            };
            return icons[type] || icons.default;
        },
        getIconClass(type) {
            const classes = {
                'evidence_pending': 'icon-warning',
                'evidence_approved': 'icon-success',
                'evidence_rejected': 'icon-danger',
                'service_assigned': 'icon-primary',
                'service_updated': 'icon-info',
                'system': 'icon-secondary'
            };
            return classes[type] || 'icon-secondary';
        },
        formatTime(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const now = new Date();
            const diffMs = now - date;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);
            const diffDays = Math.floor(diffMs / 86400000);

            if (diffMins < 1) return this.$t('notifications.justNow');
            if (diffMins < 60) return this.$t('notifications.minutesAgo', { count: diffMins });
            if (diffHours < 24) return this.$t('notifications.hoursAgo', { count: diffHours });
            if (diffDays < 7) return this.$t('notifications.daysAgo', { count: diffDays });

            return date.toLocaleDateString();
        },
        buildEvidenceUrl(token) {
            const baseUrl = process.env.VUE_APP_URL || '';
            return `${baseUrl}/supplier-evidences?token=${token}`;
        },
        formatRemainingTime(tokenExpireAt) {
            if (!tokenExpireAt) {
                return this.$t('notifications.expiringSoon') || 'Expira pronto';
            }

            const expireDate = new Date(tokenExpireAt.replace(' ', 'T'));
            const now = new Date();
            const diffMs = expireDate - now;

            if (diffMs <= 0) {
                return this.$t('notifications.expired') || 'Expiró';
            }

            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);

            const expiresIn = this.$t('notifications.expiresIn') || 'caduca en';

            if (diffHours >= 1) {
                const unitLabel = this.$t('notifications.hours') || 'hora(s)';
                return `${expiresIn} ${diffHours} ${unitLabel}`;
            } else {
                const unitLabel = this.$t('notifications.minutes') || 'minuto(s)';
                return `${expiresIn} ${diffMins} ${unitLabel}`;
            }
        },
        isTokenExpired(tokenExpireAt) {
            if (!tokenExpireAt) return false;
            const expireDate = new Date(tokenExpireAt.replace(' ', 'T'));
            return expireDate < new Date();
        },
    },
    mounted() {
        this.fetchNotifications();
    }
};
</script>

<style scoped>
.notifications-dropdown {
    display: flex;
    align-items: center;
}

.notification-bell {
    position: relative;
    cursor: pointer;
    padding: 4px;
}

.bell-icon {
    color: #d1d1ed !important;
    font-size: 24px !important;
}

.notification-badge {
    position: absolute;
    top: -2px;
    right: -4px;
    font-size: 10px;
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    padding: 0 4px;
}

.notifications-menu {
    width: 340px;
    max-height: 450px;
    padding: 0;
    overflow: hidden;
}

.notifications-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8fafc;
}

.notifications-title {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
}

.mark-all-read {
    font-size: 12px;
    padding: 0;
    text-decoration: none;
}

.notifications-list {
    max-height: 320px;
    overflow-y: auto;
}

.notification-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;
}

.notification-item:hover {
    background-color: #f1f5f9;
}

.notification-item.unread {
    background-color: #eff6ff;
}

.notification-item.unread:hover {
    background-color: #dbeafe;
}

.notification-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.notification-icon .material-icons {
    font-size: 18px !important;
    color: white;
}

.icon-warning {
    background: linear-gradient(135deg, #f59e0b, #d97706);
}

.icon-success {
    background: linear-gradient(135deg, #10b981, #059669);
}

.icon-danger {
    background: linear-gradient(135deg, #ef4444, #dc2626);
}

.icon-primary {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.icon-info {
    background: linear-gradient(135deg, #06b6d4, #0891b2);
}

.icon-secondary {
    background: linear-gradient(135deg, #64748b, #475569);
}

.notification-content {
    flex: 1;
    min-width: 0;
}

.notification-message {
    margin: 0;
    font-size: 13px;
    color: #334155;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.notification-time {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
    display: block;
}

.unread-indicator {
    width: 8px;
    height: 8px;
    background: #3b82f6;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 6px;
}

.empty-notifications {
    padding: 40px 20px;
    text-align: center;
    color: #94a3b8;
}

.empty-icon {
    font-size: 48px !important;
    opacity: 0.5;
    margin-bottom: 8px;
}

.empty-notifications p {
    margin: 0;
    font-size: 14px;
}

.notifications-loading {
    padding: 40px;
    text-align: center;
}

.notifications-footer {
    padding: 8px 16px;
    text-align: center;
    background: #f8fafc;
}

.notifications-footer .btn {
    font-size: 13px;
}
</style>

<style>
.notifications-menu.dropdown-menu {
    width: 340px !important;
    max-height: 450px;
    padding: 0 !important;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    border-radius: 8px;
}
</style>
